<template>

<v-dialog v-model="show" id="fill-order-modal" @hide="handleModalHiding"
	max-width="600" persistent :fullscreen="fullscreen">

	<v-card>

		<!--Modal Title -->
		<v-toolbar flat v-bind:class="{'green lighten-3': !$vuetify.theme.dark, 'grey darken-2': $vuetify.theme.dark }">
			<v-toolbar-title>{{ $t('common.phrase.fillOrder') }}</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn icon @click="show = false">
				<v-icon>mdi-window-close</v-icon>
			</v-btn>
		</v-toolbar>

		<!-- Modal Contents -->
		<v-card-text class="pa-5">

		<Preloader v-show="!initializationDone" />

			<div class="mx-1"  v-if="initializationDone && parsedOrder" style="margin-top: -10px">
			<OrderSummary
				ref="orderSummaryModal" :key="key"
				ismodal
				showfillorder plain
				initialorderstatechecking
				continuousorderstatechecking
				:parsedOrder="parsedOrder"
				:myaddress="myaddress" :myaccount="account"
				:accounturl="accounturl"
				:tokenurl="tokenurl"
				:txurl="txurl"
				taker-view
				v-on:fill-order-form-close-modal="show = false"
			>
			</OrderSummary>
			</div>

		</v-card-text>

		<v-card-actions v-if="fullscreen">
			<v-spacer></v-spacer>
			<v-btn color="primary" outlined text class="mr-3" @click="show = false">
				<v-icon>mdi-window-close</v-icon> {{ $t('common.verb.close')}}
			</v-btn>
		</v-card-actions>

	</v-card>
</v-dialog>


</template>

<script>

import {mapActions, mapGetters, mapState} from 'vuex'
import Preloader from "@/components/Preloader"
import OrderSummary from "@/components/OrderSummary"

export default {
	name: 'FillOrderModal',
	components: {
		Preloader,
		OrderSummary,
	},
	props: {
		fullscreen: { type: Boolean, default: false},
	},
	data () {
		return {
			parsedOrder: null,
			show: false,
			initializationDone: false,
			key: null
		}
	},
	computed: {
		...mapGetters({
			config: 'getConfig',
			network: 'getNetwork',
			account: 'getAccount',
			tokenInfo: 'getTokenInfo',
			networkNeedReload: 'networkNeedReload',
			tokenInfoNeedReload: 'tokenInfoNeedReload',
			accountNeedReload: 'accountNeedReload',
			metaMaskLoggedIn: 'metaMaskLoggedIn',
			networkConfig: 'getNetworkConfig',
		}),
		tokenurl: function () {
			return this.networkConfig.tokenURL
		},
		accounturl: function () {
			return this.networkConfig.accountURL
		},
		txurl: function () {
			return this.networkConfig.txURL
		},
		myaddress: function () {
			return this.network.userAccount
		},
	},
	methods: {
		...mapActions(['loadNetwork', 'loadTokenInfo', 'loadAccount']),

		/* ------------------------------------------------------ */
		async init () {
			// console.log('UnwrapETH init')
			this.initializationDone = false
			// if (this.networkNeedReload) {
			//   await this.loadNetwork()
			// }
			// if (this.tokenInfoNeedReload) {
			//   await this.loadTokenInfo()
			// }
			// if (this.accountNeedReload) {
			//   await this.loadAccount()
			// }
			this.parsedOrder = null
			this.initializationDone = true
		},
		async showForm (parsedOrder) {
			// console.log('FillOrderModal.showForm', parsedOrder)
			this.show = true
			await this.init()
			this.parsedOrder = parsedOrder
			// console.log('fillOrderModal', this.parsedOrder)
			const now = (new Date()).getTime()
			this.key = 'ordersummary' + now
		},
		handleModalHiding () {
			// console.log('modal hiding')
			this.$refs.orderSummaryModal.stopLoopJob()
		}
	},
	created () {
	},
	beforeDestroy () {
		// console.log('OrdersByTokenPair beforeDestroy')
		this.parsedOrder = null
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
